/**
 * shitty logger class
 */
export default new class WebPhoneLogger {

    constructor() {
        this.debug = false;
        this.prefix = '%cWebPhone: ';
    }

    info(text, data = '') {
        if (this.debug) window.console.info(this.prefix + `%c${text}`, 'color: yellow; font-weight: 600', 'color: #ccc', data);
    }

    error() {
        if (this.debug) window.console.error(this.prefix, ...arguments);
    }

    warn() {
        if (this.debug) window.console.warn(this.prefix, ...arguments);
    }

    event(text, data = '') {
        if (this.debug) window.console.info(this.prefix + `%c${text}`, 'color: yellow; font-weight: 600', 'color: #ccc', data);
    }
}